import styled from 'styled-components'
import pxToRem from '../utils/pxToRem'
import Button from '../components/Button/Button'
import {deviceMax} from '../theme/breakpoints'
import {MainContainer} from '../theme/mainContainer.styled'
import Carousel from '../components/Carousel/Carousel'
import Layout from '../components/Layout/Layout'
import SearchBarProducts from '../components/SearchBarProducts/SearchBarProducts'
import Highlight from '../components/Highlight/Highlight'

export const StyledLayout = styled(Layout)`
  gap: ${({$isLight}) => ($isLight ? `${pxToRem(20)};` : `0;`)};
`

// Header Styled Components
export const StyledHeaderContainer = styled.div`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  display: flex;
  padding: 0 ${pxToRem(10)};
  display: ${({$hideComponent}) => ($hideComponent ? 'none' : 'flex')};
  @media ${deviceMax.mobileL} {
    flex-direction: column;
    display: ${({$hideComponent}) => ($hideComponent ? `flex;` : `none;`)};
  }
`

export const StyledSearchBarProducts = styled(SearchBarProducts)`
  margin-bottom: ${pxToRem(30)};
`

export const StyledLanguageItem = styled.a`
  margin: 0 ${pxToRem(10)};
  font-size: ${({theme}) => theme.fonts.sizes.base};
  font-weight: ${({theme}) => theme.fonts.weight.medium};
`

// Main Layout Styled Components
export const StyledMainLayout = styled(MainContainer)`
  flex-direction: row;
  display: flex;
  justify-content: center;
  padding: 0;
  gap: ${pxToRem(20)};
  margin-bottom: ${({$isLight}) => (!$isLight ? `${pxToRem(20)};` : `0;`)};
  @media ${deviceMax.tablet} {
    flex-direction: column;
    max-width: 100%;
  }
`

export const StyledMainContainer = styled(MainContainer)`
  padding: 0;
  margin: 0;
`

// Left Side Styled Components
export const StyledLeftSide = styled.div`
  flex-direction: column;
  display: flex;
  width: 100%;
  max-width: ${pxToRem(384)};
  gap: ${pxToRem(20)};
`

export const StyledContactButton = styled(Button)`
  flex-direction: column;
  display: ${({$hideComponent}) => ($hideComponent ? 'none' : 'flex')};
  white-space: nowrap;
  width: 100%;
  @media ${deviceMax.mobileL} {
    display: ${({$hideComponent}) => ($hideComponent ? `flex;` : `none;`)};
    font-size: ${({theme}) => theme.fonts.sizes.button};
    line-height: ${({theme}) => theme.fonts.lineHeight.button};
    font-weight: ${({theme}) => theme.fonts.weight.bold};
  }
`

// Right Side Styled Components
export const StyledRightSide = styled.div`
  flex-direction: column;
  display: flex;
  width: 100%;
  max-width: ${pxToRem(792)};
`

export const StyledProductButton = styled(Button)`
  // for optical alignment
  margin: ${pxToRem(5)} 0 ${pxToRem(20)} auto;
  height: ${pxToRem(40)};
  @media ${deviceMax.tablet} {
    margin: auto;
    justify-content: center;
    align-items: center;
    display: flex;
    width: 100%;
    font-size: ${({theme}) => theme.fonts.sizes.button};
    line-height: ${({theme}) => theme.fonts.lineHeight.button};
    font-weight: ${({theme}) => theme.fonts.weight.bold};
  }
`

export const StyledDescriptionText = styled.div`
  font-size: ${({theme}) => theme.fonts.sizes.base};
  line-height: ${({theme}) => theme.fonts.lineHeight.base};
  font-weight: ${({theme}) => theme.fonts.weight.medium};
  margin-bottom: ${pxToRem(20)};
  @media ${deviceMax.tablet} {
    padding: 0 ${pxToRem(10)};
  }
`

export const StyledContentData = styled.div`
  flex-direction: row;
  flex-wrap: wrap;
  display: flex;
  justify-content: space-between;
  @media ${deviceMax.mobileL} {
    justify-content: center;
  }
`

// Recommended Products Styled Components
export const StyledRecommendedContent = styled.div`
  flex-direction: column;
  display: flex;
  height: fit-content;
  justify-content: center;
  background-color: ${({theme}) => theme.colors.unique.white};
  @media ${deviceMax.mobileL} {
    background-color: ${({theme}) => theme.colors.unique.transparent};
  }
`

export const StyledRecommendedHeader = styled.div`
  margin: ${pxToRem(30)} 0;
  font-size: ${({theme}) => theme.fonts.sizes.titleH3};
  line-height: ${({theme}) => theme.fonts.lineHeight.titleH3};
  font-weight: ${({theme}) => theme.fonts.weight.medium};
  text-align: center;
`

export const StyledRecommendedBody = styled(MainContainer)`
  flex-direction: row;
  gap: ${pxToRem(20)};
  display: flex;
  overflow-x: auto;
  margin-bottom: ${pxToRem(20)};
  max-width: fit-content;
  padding: ${pxToRem(10)};

  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
`

// Specific Content Styled Component
export const StyledSpecific = styled.div`
  margin-bottom: ${pxToRem(20)};
`

// Highlight Styled Component
export const StyledHighlightContainer = styled.div`
  width: ${pxToRem(385)};
  min-width: ${pxToRem(385)};
  background-color: ${({theme}) => theme.colors.unique.white};
  border-radius: ${pxToRem(5)};
  box-shadow: 0 0 ${pxToRem(10)} ${({theme}) => theme.colors.opacity.black20};
  @media ${deviceMax.mobileL} {
    width: ${pxToRem(285)};
    min-width: ${pxToRem(285)};
  }
`

export const StyledHighlight = styled(Highlight)`
  margin: 0;
  height: 100%;
  max-height: ${pxToRem(365)};
  @media ${deviceMax.mobileL} {
    width: ${pxToRem(285)};
  }
`

export const StyledDocumentsCarousel = styled(Carousel)`
  max-width: ${pxToRem(386)};
`
